module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.01a0018b.svg";